module.exports = __webpack_public_path__ + "static/media/helvetica-neue-bold.88fb497b.woff2";